import React from 'react';
import * as PropTypes from 'prop-types';
import IconButton from './IconButton';
import Confirmation from './Confirmation';
import { ConditionalWrapper } from '../../utils/components/ConditionalWrapper';
import Tooltip from '@material-ui/core/Tooltip';
import DoneIcon from '@material-ui/icons/Done';
const CompletedButton = ({ onClick, size, color, disabled, action, canBeCompleted, completed, revert, confirmLabel }) => {

    const tooltip = canBeCompleted=== false
        ? 'Rechnung noch nicht exportiert (Kein Abschluss möglich)!'
        : revert
            ? 'Buchhalterisch abgeschlossen. Klicken, um den Abschluss rückgängig zu machen!'
            : completed
                ? 'Buchhalterisch abgeschlossen (Rechnung wurde versendet)!'
                : 'Buchhalterisch noch nicht abgeschlossen (Noch kein Rechnungsversand)!';

    // only ask for confirmation when the click would actually SET the invoice
    // to completed - not when it's already completed (revert) or can't be completed
    const needsConfirmation = canBeCompleted && !completed;

    return (
        <ConditionalWrapper
            condition={needsConfirmation}
            wrapper={(children) => (
                <Confirmation
                    popupId="CompletedButton"
                    label={confirmLabel || 'Buchhalterisch abschließen?'}
                    onConfirm={onClick}
                >
                    {children}
                </Confirmation>
            )}
        >
            <IconButton
                onClick={needsConfirmation ? null : onClick}
                size={size}
                color={color}
                disabled={disabled}
                action={action}
            >
                <Tooltip title={tooltip} arrow>
                {!canBeCompleted
                     ? <DoneIcon style={{ color: 'grey' }} />
                     : completed
                        ? <DoneIcon style={{ color: 'green' }} />
                        : <DoneIcon style={{ color: 'red' }} />
                }
                </Tooltip>
            </IconButton>
        </ConditionalWrapper>
    );
};

CompletedButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    size: PropTypes.string,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    action: PropTypes.string,
    completed: PropTypes.bool.isRequired,
    canBeCompleted: PropTypes.bool.isRequired,
    revert: PropTypes.bool,
    confirmLabel: PropTypes.string,
};

CompletedButton.defaultProps = {
    size: null,
    disabled: false,
    color: 'default',
    action: null,
    completed: false,
    canBeCompleted: true,
    revert: false,
    confirmLabel: null,
};

export default CompletedButton;